import { render, staticRenderFns } from "./PromotionDetailPerChannel.vue?vue&type=template&id=353e907e&scoped=true"
import script from "./PromotionDetailPerChannel.vue?vue&type=script&lang=js"
export * from "./PromotionDetailPerChannel.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailPerChannel.vue?vue&type=style&index=0&id=353e907e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e907e",
  null
  
)

export default component.exports